import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { IDire } from '../model/dire';
import { IClientFilter } from '../model/client-filter';
import { IDireList } from '../model/dire-list';
import { of } from 'rxjs/observable/of';
import { SpinnerService } from './spinner.service';

@Injectable()
export class DireService {

   /**
   *
   * @type {string}
   */
  private clientUrl: string = environment.apiUrl + '/v1/clients';

  /**
   *
   * @type {string}
   */
  private direUrl: string = environment.apiUrl + '/v1/dire';

  /**
   *
   * @param {HttpClient} http
   */
  constructor(private http: HttpClient,
              private spinnerService: SpinnerService) {
  }

  /**
   *
   * @param {string} identifier
   * @param {IClientFilter} filter
   * @return {Observable<IDire[]>}
   */
  searchDireUnits(identifier: string, filter: IClientFilter): Observable<IDireList> {
    filter.searchedText = filter.searchedText.trim();
    filter.isReceiver = filter.isReceiver.trim();
    filter.searchedTextParent = filter.searchedTextParent.trim();
    const url = this.clientUrl + '/' + identifier + '/dires';
    return this.http.get(url, { params: filter as any })
      .map(response => {
        return response;
      }).catch(error => {
        return Observable.throw(error);
      });
  }

  /**
   * Necesario para typeahead de angular, que espera un Array en lugar de un objecto
   *
   * @param {string} identifier
   * @param {IClientFilter} filter
   * @return {Observable<IDire[]>}
   */
  autocompleteDireUnits(identifier: string, filter: IClientFilter): Observable<IDire[]> {

    (filter.createAdhesion)
      ? filter.isReceiver = 'n'
      : filter.isReceiver = '';

    (filter.searchedTextParent != '')
      ? filter.searchedTextParent = filter.searchedTextParent.trim()
      : filter.searchedText = filter.searchedText.trim();


    if (filter.searchedText === '' && filter.searchedTextParent === '') {
      return of([]);
    }
    return this.searchDireUnits(identifier, filter)
      .map(res => {
        return res.items;
      });
  }

  /**
   *
   * @param code
   */
  synchronize(code: string) {
    this.spinnerService.setSpinner(true);
    return this.http.get(this.direUrl + '/' + code + '/units')
      .map(response => {
        this.spinnerService.setSpinner(false);
        return response;
      }).catch(error => {
        this.spinnerService.setSpinner(false);
        return Observable.throw(error);
      });
  }
}


// WEBPACK FOOTER //
// ./src/app/services/dire.service.ts